module.exports = __webpack_public_path__ + "media/images/feed-ingredients-381a2b90.jpg";